import { useEffect, useRef } from 'react'
import { useAppState, useAppDispatch } from './Context'
import LocationCard from './LocationCard'

function LocationList() {
  const dispatch = useAppDispatch()
  const { locations, selectedLocation } = useAppState()
  const ref = useRef()

  const handleClick = (location) => {
    dispatch({ type: 'setSelectedLocation', payload: location })
  }

  useEffect(() => {
    if (ref.current && selectedLocation) {
      const el = ref.current.querySelector(`[data-id="${selectedLocation.id}"]`)

      if (el) {
        ref.current.scrollTop = el.offsetTop - ref.current.offsetTop
      }
    }
  }, [ref, selectedLocation])

  return (
    <div ref={ref} className="overflow-scroll flex-1 p-4 divide-y divide-olive overflow-scroll-touch">
      {locations.map((location) => (
        <LocationCard
          key={location.id}
          className="relative p-4 xl:py-8 xl:px-6"
          location={location}
          onClick={() => handleClick(location)}
        />
      ))}
    </div>
  )
}

export default LocationList
